import React from 'react'

function StarIcon(props) {
	return (
		<svg width="10" height="10" viewBox="0 0 10 10" fill="none" {...props}>
			<path d="M5 0L6.405 2.56647L9.33013 2.5L7.81 5L9.33013 7.5L6.405 7.43353L5 10L3.595 7.43353L0.669873 7.5L2.19 5L0.669873 2.5L3.595 2.56647L5 0Z" fill="#93254B" />
		</svg>

	)
}

export default StarIcon
